<template>
    <div>
        <el-tabs type="card" v-model="activeLanguageTabName">
            <el-tab-pane v-for="item in languageTemplates" :key="item.language" :name="item.language">
                <span slot="label"><i v-if="item.title == ''" class="el-icon-info" style="margin-right: 5px"></i>{{
                    `[${item.language}]` }}</span>
                <div>
                    <label style="display: block">{{
                        `标题：`
                    }}</label>
                    <el-input v-model="item.title" @input="onInput" :disabled="readonly" placeholder="（这里输入的内容会在游戏里展示）"></el-input>
                </div>
                <div style="margin-top: 5px">
                    <label style="display: block">{{
                        `正文（如果太长可以滚动）：`
                    }}</label>
                    <el-input type="textarea" rows="10" v-model="item.content" @input="onInput" :disabled="readonly"
                        placeholder="（这里输入的内容会在游戏里展示）"></el-input>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";

export default {
    data() {
        return {
            activeLanguageTabName: "",
            languageTemplates: [], // 各个语言对应的模板（标题和正文）
        }
    },

    props: {
        value: Object,
        readonly: Boolean,
    },

    async created() {
        // 查询语言集合
        let languages = await bizutil.loadAvailableLanguages();

        // 为每种语言构建模板
        for (let l of languages) {
            let languageTemplate = null;

            if (this.value && this.value.languageTemplates) {
                for (let lt of this.value.languageTemplates) {
                    if (lt.language == l) {
                        languageTemplate = lt;
                        break;
                    }
                }
            }

            if (!languageTemplate) {
                languageTemplate = {
                    language: l,
                    title: "",
                    content: "",
                };
            }

            this.languageTemplates.push(languageTemplate);
        }

        if (this.languageTemplates && this.languageTemplates.length > 0) {
            this.activeLanguageTabName = this.languageTemplates[0].language;
        }
    },

    methods: {
        onInput() {
            this.value.languageTemplates = this.languageTemplates
            this.$emit("input",  this.value);
        }
    }
}
</script>
